/// <reference types="google.maps" />
import { canUseFieldNotebook } from 'app/utils/field-notebook-access.utils';
import { FieldNotebookEntry } from 'app/core/interface/field-notebook';

import { area, featureCollection } from '@turf/turf';

import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChildren,
  inject,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  FormControlName,
  UntypedFormGroup,
  Validators,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrevisaoTempoService } from 'app/core/services/previsao-tempo.service';
import { MapsLoaderService } from 'app/core/services/maps-loader.service';
import { UserTalhaoListService } from 'app/core/services/user-talhao-list.service';
import { GenericValidator } from 'app/utils/generic-form-validator';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AnalyticsService } from 'app/core/services/analytics.service';
import { Geometry } from '@turf/turf';
import { AuthStateService } from 'app/core/services/auth-state.service';
import { zip } from '@mapbox/shp-write';
import { UserFilesManager } from 'app/utils/user-files-manager';
import { FileManagerService } from 'app/core/services/file-manager.service';
import { unzipFiles } from 'app/utils/zip-manager';
import { normalizeString } from 'app/utils/string.utils';
import { FieldBoundarySuggestionSource } from 'app/utils/field-boundary-suggestion.utils';
import { CreateFieldNavigationState } from 'app/shared/models/create-field-navigation-state';
import { ToastrService } from 'ngx-toastr';

// A Map rather than an object literal, so that a key such as `constructor`
// never resolves to an inherited member.
const BOUNDARY_SUGGESTION_MESSAGE_KEYS = new Map<unknown, string>([
  [
    FieldBoundarySuggestionSource.DEVICE_BOUNDARY,
    'fields.suggested-boundary-device',
  ],
  [
    FieldBoundarySuggestionSource.COVERAGE,
    'fields.suggested-boundary-coverage',
  ],
]);

interface PolygonGeometry {
  type: 'Polygon';
  coordinates: number[][][];
}

interface Feature {
  type: 'Feature';
  geometry: PolygonGeometry;
  properties: { [key: string]: any };
}

interface FeatureCollection {
  type: 'FeatureCollection';
  features: Feature[];
}

@Component({
  standalone: false,
  selector: 'app-cria-talhoes',
  templateUrl: './cria-talhoes.component.html',
  styleUrls: ['./cria-talhoes.component.scss'],
})
export class CriaTalhoesComponent implements OnInit, OnDestroy {
  offCanvasOne = new Subject<boolean>();
  talhaoById = [];
  blockButton: boolean = true;
  isGoogleMapLoaded: boolean;
  mapPolygonColorSubject: Subject<string> = new Subject();
  updateIsPolygonClosed: Subject<boolean> = new Subject();
  googleMapCenterCoordinate: Subject<{ lat: number; lng: number }> =
    new Subject();

  get notebookEnabled(): boolean {
    return canUseFieldNotebook(this.authState.getUser()?.id);
  }

  parcelReference = '';
  notebookCrop: FieldNotebookEntry['crop'];
  selectedColor = '#000';

  @Input() emitEventEditarTalhaoById;
  @ViewChildren(FormControlName, { read: ElementRef })
  control = new UntypedFormControl('');
  cityInputUpdate = new Subject<string>();
  formInputElements: ElementRef[];
  filteredStreets: any[];
  cityName = '';

  fetchFieldData: Subject<boolean> = new Subject();
  public showModalSubject: Subject<boolean> = new Subject();
  public showModal: boolean;
  public sizeModal: 'sm' | 'md' | 'lg' | 'xl' | 'fullscreen' = 'md';

  geometry: FeatureCollection = {
    features: [
      {
        geometry: {
          coordinates: [],
          type: 'Polygon',
        },
        properties: {},
        type: 'Feature',
      },
    ],
    type: 'FeatureCollection',
  };
  isPolygonClosed = false;
  isEditingPolygon = false;
  polygons: google.maps.LatLngLiteral[][] = [];

  showPolygon = false;

  apiLoaded: Observable<boolean>;

  vertices: google.maps.LatLngLiteral[] = [];

  mapOptions: google.maps.MapOptions = { draggable: false };

  markerPositions: google.maps.LatLngLiteral[] = [];
  createFieldForm: UntypedFormGroup;
  searchForm: FormGroup;
  locations: any[] = [];

  public validationMessages: { [key: string]: { [key: string]: string } };
  public genericValidator: GenericValidator;
  public displayMessage: { [key: string]: string } = {};
  private readonly subscription: Subscription;

  inputLat: number;
  inputLong: number;
  formData: { latitude: number; longitude: number };
  enteredCharacters: string = '';
  initialFieldArea: string;
  exceededCharacterLimit: boolean = false;
  userId: string;
  taskCenter: any;
  fieldName: any;
  isDisabled = false;
  /** Notice shown while the polygon on the map is a suggestion from a task. */
  boundarySuggestionMessageKey: string | null = null;
  private readonly mapsLoader = inject(MapsLoaderService);
  private readonly authState = inject(AuthStateService);
  private readonly location = inject(Location);
  private readonly cloudantManager: UserFilesManager;
  userLogged: any;
  nameOfFields: string[];
  saving = false;
  constructor(
    httpClient: HttpClient,
    public router: Router,
    public userTalhoesService: UserTalhaoListService,
    public translateService: TranslateService,
    public formBuilder: UntypedFormBuilder,
    private formBuilderSearch: FormBuilder,
    public previsaoTempoService: PrevisaoTempoService,
    private readonly cdr: ChangeDetectorRef,
    private readonly analyticsService: AnalyticsService,
    public fileManagerService: FileManagerService,
    private readonly toastr: ToastrService,
  ) {
    this.cloudantManager = new UserFilesManager(fileManagerService, httpClient);
    const usuarioLogado = this.authState.getUser();
    this.userId = usuarioLogado?.id;
    this.analyticsService.sendPageView('/criar-talhao/');
    this.analyticsService.trackEvent(
      'Accessed the create field',
      'Create_Field',
    );
    this.validationMessages = {
      name: {
        required: '',
      },
      description: {},
    };

    this.populateValidateObj();
    this.genericValidator = new GenericValidator(this.validationMessages);
    this.apiLoaded = this.mapsLoader.load();
  }
  openInfomationsOfField() {
    this.getCityName(this.geometry);
    if (this.isPolygonClosed) {
      this.isEditingPolygon = false;
      this.offCanvasOne.next(true);
    }
  }

  ngOnInit(): void {
    this.userLogged = this.authState.getUser()?.id;
    this.analyticsService.trackEvent(
      'create_field_page_has_been_opened',
      'Open Page Create Field',
    );
    this.getNameOfFields();
    const { feature, boundarySource, center, fieldName } =
      this.getNavigationState();
    // The task's field name must stay as it is whatever else was handed over:
    // it is how the task finds its field.
    this.lockFieldName(fieldName);
    if (feature) {
      const prefilledFeatureCollection = featureCollection([feature]);
      this.initialFieldArea = (
        area(prefilledFeatureCollection) / 10000
      ).toFixed(3);
      // The drawing tools only handle a Polygon; a MultiPolygon shapefile is
      // handed to them as is, as it always was.
      this.geometry = prefilledFeatureCollection as FeatureCollection;
      this.isPolygonClosed = true;
      this.boundarySuggestionMessageKey =
        BOUNDARY_SUGGESTION_MESSAGE_KEYS.get(boundarySource) ?? null;
    } else if (center) {
      this.taskCenter = center;
    }
    this.cityInputUpdate
      .pipe(debounceTime(350), distinctUntilChanged())
      .subscribe((event: any) => {
        this.updateAutocompleteCitiesList(event.target.value);
      });

    this.createFieldForm = this.formBuilder.group({
      area: [this.initialFieldArea],
      name: [
        { value: this.fieldName, disabled: this.isDisabled },
        [Validators.required],
      ],
      description: ['', [Validators.required, Validators.maxLength(200)]],
    });

    this.searchForm = this.formBuilderSearch.group({
      searchCity: [''],
      lineName: [''],
      selectedLocation: [''],
    });
  }

  /** What the previous screen handed over; see `CreateFieldNavigationState`. */
  private getNavigationState(): CreateFieldNavigationState {
    const state = this.location.getState() as CreateFieldNavigationState | null;
    return state ?? {};
  }

  private lockFieldName(fieldName: string | undefined): void {
    if (fieldName) {
      this.fieldName = fieldName;
      this.isDisabled = true;
    }
  }

  fieldNameDuplicated(fieldName) {
    if (fieldName) {
      const name = fieldName
        .replace(/\s+/g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
      if (this.nameOfFields?.includes(name)) {
        this.blockButton = true;
        return true;
      } else {
        this.blockButton = false;
        return false;
      }
    }
  }

  getNameOfFields() {
    this.userTalhoesService.getAllTalhoes().subscribe((talhoes) => {
      this.nameOfFields = talhoes.map((field) =>
        field.name
          .replace(/\s+/g, '_')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase(),
      );
    });
  }

  onGoogleMapLoaded(mapLoaded): void {
    this.isGoogleMapLoaded = mapLoaded;
    this.cdr.detectChanges();
    if (this.taskCenter) {
      this.centerGoogleMap(this.taskCenter.lat, this.taskCenter.lng);
    }
  }

  togglePolygonEditButtonTitle(): string {
    if (
      (this.geometry.features[0].geometry as Geometry).coordinates.length > 0
    ) {
      return this.translateService.instant('fields.title-button-draw-the-hole');
    }
    return this.translateService.instant('fields.title-button-draw-the-field');
  }

  callTogglePolygonDrawing() {
    this.updateIsPolygonClosed.next(false);
    this.isEditingPolygon = true;
    this.isPolygonClosed = false;
    this.analyticsService.trackEvent(
      'Clicked on draw field button',
      'Create_Field',
    );
  }

  hideOffCanvas(): void {
    this.offCanvasOne.next(false);
  }

  populateValidateObj() {
    this.translateService
      .get('global.validate.user-required')
      .subscribe((res: string) => {
        this.validationMessages.name.required = res;
      });
  }
  isValidLatitude(latitude: string): boolean {
    const trimmedLatitude = latitude.replace(/\s+/g, '');
    const latitudeRegex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
    return latitudeRegex.test(trimmedLatitude);
  }
  isValidLongitude(longitude: string): boolean {
    const trimmedLongitude = longitude.replace(/\s+/g, '');
    const longitudeRegex = /^[-+]?((1[0-7]|[1-9])?\d(\.\d+)?|180(\.0+)?)$/;
    return longitudeRegex.test(trimmedLongitude);
  }
  isCommaAfterLatitude(input: string): boolean {
    const indexOfComma = input.indexOf(',');
    const indexOfNewline = input.indexOf('\n');
    return indexOfComma !== -1 && indexOfComma > indexOfNewline;
  }
  handleChange(event) {
    const inputValue: string = event.target.value;
    if (event.key === 'Enter' || event.type === 'submit') {
      this.enteredCharacters = inputValue.substring(
        inputValue.lastIndexOf('\n') + 1,
      );
      if (!this.isCommaAfterLatitude(this.enteredCharacters)) {
        this.translateService
          .get('global.alert.search-cordinate')
          .subscribe((res: string) => {
            this.toastr.warning(res, '', {
              positionClass: 'toast-top-full-width',
              disableTimeOut: false,
            });
          });
        return;
      }
      const [latitude, longitude] = this.enteredCharacters.split(',');
      if (this.isValidLatitude(latitude) && this.isValidLongitude(longitude)) {
        const parsedLatitude = parseFloat(latitude);
        const parsedLongitude = parseFloat(longitude);
        this.centerGoogleMap(parsedLatitude, parsedLongitude);
      } else {
        this.translateService
          .get('global.validate.incorrect-coordinate')
          .subscribe((res: string) => {
            this.toastr.warning(res, '', {
              positionClass: 'toast-top-full-width',
              disableTimeOut: false,
            });
          });
      }
    }
    this.cityInputUpdate.next(event);
  }

  updateAutocompleteCitiesList(location: string) {
    this.previsaoTempoService
      .getSearchLocation(location)
      .subscribe((result) => {
        const uniqueIds = new Set();
        const unique = result.filter((element) => {
          const isDuplicate = uniqueIds.has(element.address);
          uniqueIds.add(element.address);
          return !isDuplicate;
        });

        this.filteredStreets = unique;
      });
  }

  onInputChange(event: any) {
    const endereco = event.target.value;
    if (endereco) {
      this.previsaoTempoService.buscarCoordenadas(endereco).subscribe({
        next: (data: any) => {
          if (data.status === 'OK') {
            this.locations = data.results;
          }
        },
        error: () => {
          this.translateService
            .get('fields.error-search-address')
            .subscribe((res: string) => {
              this.toastr.error(res, '', {
                positionClass: 'toast-top-full-width',
                disableTimeOut: false,
              });
            });
        },
      });
    }
  }
  centerGoogleMap(latitude: number, longitude: number) {
    this.googleMapCenterCoordinate.next({ lat: latitude, lng: longitude });
  }

  addMarker(event: google.maps.MapMouseEvent) {
    this.markerPositions.push(event.latLng.toJSON());
  }

  options: google.maps.MapOptions = {
    center: { lat: 40, lng: -20 },
    zoom: 13,
    fullscreenControl: false,
    rotateControl: false,
    scaleControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    mapTypeId: 'satellite',
  };

  cancelEditPolygons(): void {
    this.analyticsService.trackEvent(
      'Clicked on the cancel fields button',
      'Create_Field',
    );
    this.polygons = [];
    this.markerPositions = [];
    this.router.navigate(['/my-fields']);
  }

  closePolygon(event) {
    this.vertices = [...this.markerPositions, this.markerPositions[0]];
    this.polygons.push(this.vertices);
  }

  clearPolygons() {
    this.analyticsService.trackEvent(
      'Clicked on the clear fields button',
      'Create_Field',
    );
    (this.geometry.features[0].geometry as Geometry).coordinates = [];
    this.boundarySuggestionMessageKey = null;
    this.isEditingPolygon = true;
    this.isPolygonClosed = false;
    this.fetchFieldData.next(true);
    this.createFieldForm.controls.area.setValue(0);
    this.updateIsPolygonClosed.next(false);
  }

  createTalhao() {
    const notebookAttributes: {
      parcelReference?: string;
      crop?: FieldNotebookEntry['crop'];
    } = {};
    if (this.notebookEnabled) {
      notebookAttributes.parcelReference = this.parcelReference;
      notebookAttributes.crop = this.notebookCrop;
    }
    this.saving = true;
    this.userTalhoesService
      .postTalhao({
        data: {
          geometry: this.geometry,
          name: this.createFieldForm.controls.name.value,
          city: this.cityName,
          color: this.selectedColor,
          description: this.createFieldForm.controls.description.value,
          ...notebookAttributes,
        },
      })
      .subscribe(
        (talhoes) => {
          if (talhoes) {
            this.createShapefile(talhoes.id);
            this.analyticsService.trackEvent('Created a field', 'Create_Field');
          } else {
            this.translateService
              .get('global.validate.http-status-code-400')
              .subscribe((res: string) => {
                this.toastr.error(res, '', {
                  positionClass: 'toast-top-full-width',
                  disableTimeOut: false,
                });
                this.analyticsService.trackEvent(
                  'Not created a field',
                  'Create Field',
                );
              });
          }
        },
        () => {
          this.translateService
            .get('global.validate.http-status-code-400')
            .subscribe((res: string) => {
              this.toastr.error(res, '', {
                positionClass: 'toast-top-full-width',
                disableTimeOut: false,
              });
              this.analyticsService.trackEvent(
                'Not created a field',
                'Create Field',
              );
            });
        },
      );
  }

  async createShapefile(id: string) {
    const name = normalizeString(this.createFieldForm.controls.name.value);

    const shapefilesZip = await zip<'blob'>(this.geometry, {
      types: {
        polygon: name,
      },
      compression: 'STORE',
      outputType: 'blob',
    });

    const files = await unzipFiles(shapefilesZip, {
      filterExtensions: ['cpg', 'prj'],
    });
    const fileClassification = {
      boundaries: files.map((file) => file.name),
      recommendation_files: [],
      guides_files: [],
    };
    this.cloudantManager
      .saveDataAndUploadUserFiles(
        this.userLogged,
        files,
        'fields',
        id,
        fileClassification,
      )
      .subscribe(() => {
        this.translateService
          .get('global.alert.http-status-code-200')
          .subscribe((res: string) => {
            this.toastr.success(res, '', {
              positionClass: 'toast-top-full-width',
              disableTimeOut: false,
            });
            this.router.navigate(['/my-fields']);
          });
      });
  }

  onUpdatePolygons() {
    return (geometry, polygonStatus: boolean, area: number) => {
      if (Object.keys(geometry).length > 0 && polygonStatus && area) {
        this.createFieldForm.controls.area.setValue(area.toFixed(3));
        this.isPolygonClosed = polygonStatus;
        this.geometry = geometry;
        this.getCityName(geometry);
        this.isEditingPolygon = false;
      }
    };
  }

  getCityName(geometry) {
    const coordinates = geometry.features[0].geometry.coordinates[0][0];
    this.previsaoTempoService
      .getLocationName(coordinates[1], coordinates[0])
      .subscribe((cityName) => {
        this.cityName = cityName;
      });
  }

  selectClick(event) {
    this.mapPolygonColorSubject.next(event.target.value);
    this.selectedColor = event.target.value;
  }

  selectCoresTalhao(event) {
    this.mapPolygonColorSubject.next(event.target.value);
    this.selectedColor = event.target.value;
  }
  importShp(): void {
    this.translateService
      .get('Estamos trabalhando nesta funcionalidade!')
      .subscribe((res: string) => {
        this.toastr.info(res, '', {
          positionClass: 'toast-top-full-width',
          disableTimeOut: false,
        });
      });
  }

  openModal() {
    this.showModal = true;
    this.sizeModal = 'md';
    this.showModalSubject.next(true);
  }
  closeModal() {
    this.showModal = false;
    this.showModalSubject.next(false);
  }

  verifyTextAreaSize() {
    const textareaSize = this.createFieldForm.controls.description.value.length;
    if (textareaSize > 200) {
      this.exceededCharacterLimit = true;
    } else {
      this.exceededCharacterLimit = false;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
